module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-600.08745702.woff2";